// extracted by mini-css-extract-plugin
export default {"video":"Hbtus","videoContainer":"gaSFk"};